import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData, getpastConfYears } from '../../services/pastConfTestimonialsServices';
import { Button, Modal, Form } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import { isQuillContentEmpty, cleanQuillHtml } from '../../utils/common';
import { validateFile} from '../../utils/validators';


const modules = {
  toolbar: [
    // Font family and size
    [{ 'font': [] }, { 'size': ['small', false, 'large', 'huge'] }],

    // Headings
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    // Text styles
    ['bold', 'italic', 'underline', 'strike'],

    // Subscript / Superscript
    [{ 'script': 'sub' }, { 'script': 'super' }],

    // Blockquote and code block
    ['blockquote', 'code-block'],

    // Color and background
    [{ 'color': [] }, { 'background': [] }],

    // Text alignment and direction (RTL)
    [{ 'align': [] }, { 'direction': 'rtl' }],

    // Ordered / bullet list
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],

    // Indent and outdent
    [{ 'indent': '-1' }, { 'indent': '+1' }],

      ['link'],

    // Clear formatting
    ['clean']
  ]
};
  
const formats = [
  'font', 'size',
  'header',
  'bold', 'italic', 'underline', 'strike',
  'script',
  'blockquote', 'code-block',
  'color', 'background',
  'align', 'direction',
  'list', 'bullet', 'indent',
  'link', 'image', 'video',
];

const Pastconftestimonials = () => {
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    uploadedfile: null, 
    year: '', 
    speaker_pic_alt: '',
    speaker_name: '',
    speaker_affi: '',
    speaker_testimonial: ''  
  });
  const [modalType, setModalType] = useState(''); // 'add' or 'edit'
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setselectedData] = useState(null);
  const [pastConfYears, setpastConfYears] = useState([]);
  
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});


  // Fetch data from API
      const fetchData = useCallback(async () => {
        setLoading(true);
        try{
        const response = await getData();
        setData(response);
        }
        catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setTimeout(() => {
            setLoading(false);
          }, 500);
        }  
      }, []);
  
      useEffect(() => {
        fetchData();
      }, [fetchData]);

    
    //validate the form 
  const validateForm = () => {
  const newErrors = {};
  if (!formData.uploadedfile && formData.uploadedfile === null) {
    if (!errors.uploadedfile) newErrors.uploadedfile = "Speaker image is required";
  }
  if (!formData.year) newErrors.year = "Year is required";
  if (!formData.speaker_pic_alt) newErrors.speaker_pic_alt = "Speaker picture alt text is required";
  if (!formData.speaker_name) newErrors.speaker_name = "Speaker name is required";
  if (!formData.speaker_affi) newErrors.speaker_affi = "Speaker affiliation is required";
  if (isQuillContentEmpty(formData.speaker_testimonial.trim())) newErrors.speaker_testimonial = "Speaker testimonial is required";
  setErrors((prev) => ({ ...prev, ...newErrors }));
  return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
};
 
  
  useEffect(() => {
      const fetchpastConfYears = async () => {
        try {
          const data = await getpastConfYears(); // Fetch data from the service
          setpastConfYears(data); // Set the types in state
        } catch (error) {
          console.error('Error fetching media partners type:', error);
        }
      };
      fetchpastConfYears();
    }, []);
  

    const handleChange = async(e) => {
      try {
      const { name, value, files } = e.target;
      const file = files?.[0]
      
      // Create a copy of the current form data
      let updatedData = { ...formData };
      let updatedErrors = { ...errors };
      if (file) {
        const fileType = file.type.includes("image") ? "img" : "pdf";
        const isValid = await validateFile(file, setErrors,name,fileType);
        if (isValid) {
          updatedData[name] = file;
          updatedErrors[name] = '';
        }
        else{
          return ; // Don't update if invalid
        }
      }
      else{
        updatedData[name] = value;
        if (value) {
        updatedErrors[name] = ''; // Clear error if corrected
      }
      }
       setFormData(updatedData);
       setErrors(updatedErrors);
    } catch (error) {
      console.error("Error in handleChange:", error);
    }
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      // Validate form data
      if (!validateForm()) {
          return
        }
      try{
      const form = new FormData();
      form.append('id', formData.id);
      form.append('year', formData.year);
      form.append('speaker_pic_alt', formData.speaker_pic_alt);
      form.append('speaker_name', formData.speaker_name);
      form.append('speaker_affi', formData.speaker_affi);
      form.append('speaker_testimonial', cleanQuillHtml(formData.speaker_testimonial));        
      form.append('uploadedfile', formData.uploadedfile);
  
      if (modalType === 'add') {
        const result = await addData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Saved Successfully!", {
                        position: 'top-right',
                      });
        } else {
          toast.error(result.message ||"Failed to Added data. Please try again.", {
                        position: 'top-right',
                      });
        }
      } else if (modalType === 'edit') {
        const result = await updateData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Updated Successfully!", {
                        position: 'top-right',
                      });
        } else {
          toast.error(result.message ||"Failed to update data. Please try again.", {
                        position: 'top-right',
                      });
        }
      }
    }
    catch (error) {
        console.error("Error during form submission:", error);
    }
    };

    const handleDelete = async () => {
      try{
      if (selectedData) {
        const result = await deleteData(selectedData.id);
        if (result.status === 200) {
          fetchData();
          setShowDeleteConfirmModal(false);
          toast.success("Deleted Successfully!", {
                        position: 'top-right',
                      });
        } else {
          toast.error(result.message ||"Failed to Delete data. Please try again.", {
                        position: 'top-right',
                      });
        }
      }
    }
    catch(error){
      console.log("Failed to delete getData")
    }

    };
  
    
  // Handle change for Quill editor
  const handletestimonialChange = (value) => {
    setErrors((prev) => ({ ...prev, speaker_testimonial: isQuillContentEmpty(value) ? 'Description is required' : '' }));
    setFormData((prev) => ({ ...prev, speaker_testimonial: value }));
  };
  
  const openModal = (type, data = { 
    id: null,
    uploadedfile: null, // File input should be reset
    year: '',
    speaker_pic_alt: '',
    speaker_name: '',
    speaker_affi: '',
    speaker_testimonial: '',
    
   }) => {
    setModalType(type);
    setFormData(data);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const openDeleteConfirmModal = (data) => {
    setselectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const closeDeleteConfirmModal = () => {
    setShowDeleteConfirmModal(false);
    setselectedData(null);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


   // Memoized filtered data based on search query
    const filteredData = useMemo(() => {
        const filtered =  data.filter(
          (data) =>
          data.speaker_name.toLowerCase().includes(searchText.toLowerCase()) ||
          data.speaker_affi.toLowerCase().includes(searchText.toLowerCase()) 
        );

        const sortedData = [...filtered].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        return sortedData;
      }, [data, searchText]);
      

  const columns = [
    {
        name: '#',
        selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
        sortable: false,
        width: '80px',
      },
    {
        name: 'Speaker Picture',
        selector: (row) => <img src={row.speaker_pic} width="100" alt={row.speaker_pic_alt} style={{ width: '60px', height: '40px', objectFit: 'cover' }}
                crossOrigin="anonymous"/>,
        sortable: false,
    },
    
    {
        name: 'Speaker Name',
        selector: (row) => row.speaker_name,
        cell: (row) => (
            <span title={row.speaker_name}>
              {row.speaker_name}
            </span>
          ),
        sortable: true,
    },
    {
        name: 'Speakers Affilation',
        selector: (row) => row.speaker_affi,
        cell: (row) => (
            <span title={row.speaker_affi}>
              {row.speaker_affi}
            </span>
          ),
        sortable: true,
    },
    {
        name: 'Year',
        selector: (row) => row.year,
        cell: (row) => (
            <span title={row.year}>
              {row.year}
            </span>
          ),
        sortable: true,
    },
    
    {
      name: 'Actions',
      cell: (row) => (
                <div>
                  <Button
                    className="me-2"
                    variant="warning"
                    size="sm"
                    onClick={() => openModal('edit', {
                      id: row.id,
                      uploadedfile: row.speaker_pic, // File input should be reset
                      year: row.year, 
                      speaker_pic_alt: row.speaker_pic_alt, 
                      speaker_name: row.speaker_name, 
                      speaker_affi: row.speaker_affi, 
                      speaker_testimonial: row.speaker_testimonial,      
                    })}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => openDeleteConfirmModal(row)}
                  >
                    Delete
                  </Button>
                </div>
              ),
    },
  ];
  
  useEffect(() => {
        const tooltipMap = {
          'ql-bold': 'Bold',
          'ql-italic': 'Italic',
          'ql-underline': 'Underline',
          'ql-strike': 'Strikethrough',
          'ql-script[value="sub"]': 'Subscript',
          'ql-script[value="super"]': 'Superscript',
          'ql-blockquote': 'Blockquote',
          'ql-code-block': 'Code Block',
          'ql-color': 'Text Color',
          'ql-background': 'Background Color',
          'ql-align': 'Align',
          'ql-direction': 'Text Direction',
          'ql-list[value="ordered"]': 'Ordered List',
          'ql-list[value="bullet"]': 'Bullet List',
          'ql-indent[value="-1"]': 'Outdent',
          'ql-indent[value="+1"]': 'Indent',
          'ql-link': 'Insert Link',
          'ql-clean': 'Clear Formatting',
        };
  
      const setTooltips = () => {
        Object.entries(tooltipMap).forEach(([selector, title]) => {
          const el = document.querySelector(`.ql-toolbar .ql-formats .${selector}`);
          if (el && !el.title) {
            el.setAttribute('title', title);
          }
        });
      };
  
      const observer = new MutationObserver((mutations, obs) => {
        const toolbarReady = document.querySelector('.ql-toolbar');
        if (toolbarReady) {
          setTooltips();
          obs.disconnect(); // Stop observing once done
        }
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
  
    return () => observer.disconnect() // Clean up on unmount
    }, []);

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
        <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Past Events Pages / Past Conferences <b>/ Conference Testimonials</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>
          {/* <h1 className="title_slider">
            Past Conferences / Conference Testimonials
            <Button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
              Add
            </Button>
          </h1> */}

          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal show={showModal} className="modal-lg" onHide={closeModal} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit}>
                <div className='row'>
                    <Form.Group className="col-md-6 mb-3">
                        <Form.Label className='form-label-custom'>Past Conference <small className='text-danger'> * </small></Form.Label>
                        <Form.Control className="form-select mb-3" as="select" name="year" value={formData.year} onChange={handleChange} isInvalid={!!errors.year} >
                            <option value="">Select Year</option>
                            {pastConfYears.map((years) => (
                                <option key={years.year} value={years.year}>
                                {years.display_year}
                                </option>
                            ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                                        {errors.year}
                                    </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="col-md-6 mb-3">
                        <Form.Label className='form-label-custom'>
                        Speaker's Image <small className='text-danger'> * </small><small className="text-primary form-label-note"> (Dimension: 300x300 | Size: 20-30kb)</small>
                        </Form.Label>
                        <Form.Control
                            type="file"
                            name="uploadedfile"
                            onChange={handleChange}
                            isInvalid={!!errors.uploadedfile}
                        />
                        <Form.Control.Feedback type="invalid">
                        {errors.uploadedfile}
                    </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="col-md-6 mb-3">
                        <Form.Label className='form-label-custom'>Title <small className='text-danger'> * </small></Form.Label>
                        <Form.Control
                            type="text"
                            name="speaker_pic_alt"
                            value={formData.speaker_pic_alt}
                            onChange={handleChange}
                            isInvalid={!!errors.speaker_pic_alt}
                        />
                        <Form.Control.Feedback type="invalid">
                        {errors.speaker_pic_alt}
                    </Form.Control.Feedback>
                    </Form.Group>               
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Speaker's Name<small className='text-danger'> * </small></Form.Label>
                  <Form.Control
                    type="text"
                    name="speaker_name"
                    value={formData.speaker_name}
                    onChange={handleChange}
                    isInvalid={!!errors.speaker_name}
                  />
                  <Form.Control.Feedback type="invalid">
                        {errors.speaker_name}
                    </Form.Control.Feedback>
                </Form.Group>             
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Speaker Affiliation <small className='text-danger'> * </small></Form.Label>
                  <Form.Control
                    type="text"
                    name="speaker_affi"
                    value={formData.speaker_affi}
                    onChange={handleChange}
                    isInvalid={!!errors.speaker_affi}
                  />
                  <Form.Control.Feedback type="invalid">
                        {errors.speaker_affi}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                <Form.Label className='form-label-custom'>Speaker's Testimonial<small className='text-danger'> * </small></Form.Label>
                <ReactQuill
                    value={formData.speaker_testimonial}
                    onChange={handletestimonialChange}
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    placeholder="Enter description"
                    className={`react-quill-editor ${errors.speaker_testimonial ? 'border border border-1 border-danger rounded' : ''}`}
                />
                {errors.speaker_testimonial && (
                    <div className="invalid-feedback d-block">
                      {errors.speaker_testimonial}
                    </div>
                  )}
                </Form.Group>
                </div>

                <Modal.Footer className='border-0'>
                  <Button variant="secondary" onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    {modalType === 'add' ? 'Add' : 'Save'}
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Delete Confirmation Modal */}
          <Modal show={showDeleteConfirmModal} onHide={closeDeleteConfirmModal}>
            <Modal.Header closeButton>
              <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this row?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeDeleteConfirmModal}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
      )}
      </div>
    </div>
  );
};

export default Pastconftestimonials;